import { Avatar, Icon, PageContainer, PageHeader, Skeleton } from "@/components/ui"
import { Back } from "@/icons"

/**
 * Loading skeleton that mirrors the real checkout layout structure (sticky
 * header + stepper + step content) so the swap to the loaded wizard is a
 * seamless crossfade instead of a jarring layout change.
 */
export function CheckoutSkeleton() {
  return (
    <div className="pb-44" aria-busy="true">
      <PageHeader
        raised
        surface="card"
        gutter="inset"
        offsetActiveOrderBar
        identity={
          <>
            <Icon as={Back} size="lg" tone="primary" className="mx-1.5" />
            <Avatar size="md" />
            <div className="space-y-1.5">
              <Skeleton className="h-4 w-28" />
              <Skeleton className="h-3 w-36" />
            </div>
          </>
        }
        trailing={<Skeleton className="h-4 w-16" />}
        bottom={
          <PageContainer className="pb-4 pt-1">
            <Skeleton className="mb-2 h-4 w-48" />
            <div className="flex gap-2">
              {[0, 1, 2].map((segment) => (
                <Skeleton key={segment} shape="pill" className="h-2 flex-1" />
              ))}
            </div>
          </PageContainer>
        }
      />
      <main className="min-h-empty">
        <PageContainer className="pt-6 sm:pt-8">
          <Skeleton className="h-7 w-56 max-w-full" />
          <Skeleton className="mt-3 h-4 w-72 max-w-full" />
          <div className="mt-6 space-y-3">
            {[0, 1, 2].map((card) => (
              <Skeleton key={card} className="h-24 w-full" />
            ))}
          </div>
        </PageContainer>
      </main>
    </div>
  )
}
